import { initCKEditor } from "../../../framework/ckeditor_with_tags";
export { initTagsList, EMAIL_TAGS_LIST_ID } from "../../../framework/ckeditor_with_tags";

export const initEmailCKEditors = () => {
  const TOOLBAR = [
    { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "-", "Undo", "Redo"] },
    { name: "basicstyles", items: ["Bold", "Italic", "Underline"] },
    {
      name: "paragraph",
      items: [
        "NumberedList",
        "BulletedList",
        "-",
        "Outdent",
        "Indent",
        "-",
        "JustifyLeft",
        "JustifyCenter",
        "JustifyRight",
        "JustifyBlock",
      ],
    },
    { name: "links", items: ["Link", "Unlink"] },
    { name: "colors", items: ["TextColor"] },
  ];

  if (window.CKEDITOR_STYLESHEETS) {
    return Promise.all([
      initCKEditor("email_template_subject", {
        height: 38,
        toolbar: [],
        contentsCss: window.CKEDITOR_STYLESHEETS.one_line,
        oneLine: true,
      }),
      initCKEditor("email_template_html", {
        height: 300,
        toolbar: TOOLBAR,
        contentsCss: window.CKEDITOR_STYLESHEETS.email,
      }),
    ]);
  }
};
